import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class NewsletterService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/newsletter');

  newsletterSubscribe(storeId: string, email: string) {
    return this.api.getJSON(`${NewsletterService.baseUrl}?email=${encodeURIComponent(email)}&storeId=${storeId}`).pipe(
      catchError(() => of({}))
    );
  }
}
